module.exports = __webpack_public_path__ + "static/eco_power_wash_bird-f9102256066b0a2b3a5dd49fcc7775a7.jpg";